var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27Z",
    fill: "#FFC942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.3C8.4 18.1 8.2 18 8 18C7.8 18 7.6 18.1 7.5 18.3L6 22.5C6 22.7 6 22.8 6 23C6 24.1 6.9 25 8 25C9.1 25 10 24.1 10 23C10 22.8 10 22.7 9.9 22.5L8.5 18.3Z",
    fill: "#00A6F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20.5L7 22.8C7 22.9 7 22.9 7 23C7 23.1 7 23.3 7.1 23.4C7.3 23.9 8 23.7 8 23.2V20.5Z",
    fill: "#90EDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 20.9C18.7 21.1 19.1 20.6 18.9 20.1C18.4 19 17.5 18 16 18C14.5 18 13.6 19 13.1 20.1C12.9 20.6 13.3 21.2 13.8 20.9C14.3 20.6 15.1 20 16 20C16.9 20 17.7 20.7 18.2 20.9Z",
    fill: "#2D2C2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C11.4 15 11 14.6 11 14V13C11 12.4 11.4 12 12 12C12.6 12 13 12.4 13 13V14C13 14.6 12.6 15 12 15Z",
    fill: "#2D2C2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15C19.4 15 19 14.6 19 14V13C19 12.4 19.4 12 20 12C20.6 12 21 12.4 21 13V14C21 14.6 20.6 15 20 15Z",
    fill: "#2D2C2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad_face.1e2629a261f810c53f4802b064bd26ab.svg";
export { ForwardRef as ReactComponent };